/* @ngInject */
export default class DocumentsApprovalCtrl {
    constructor(
        $sce,
        $scope,
        $timeout,
        $rootScope,
        BuildingsService,
        NavigationService,
        LocalStorageService,
        NotificationService,
        AuthorizationService,
        DashboardService,
        ApprovalDocumentsDataService,
    ) {
        this.$sce = $sce;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.BuildingsService = BuildingsService;
        this.NavigationService = NavigationService;
        this.LocalStorageService = LocalStorageService;
        this.NotificationService = NotificationService;
        this.AuthorizationService = AuthorizationService;
        this.DashboardService = DashboardService;
        this.ApprovalDocumentsDataService = ApprovalDocumentsDataService;
        this.hasInitialisedFromSession = false;

        this.$rootScope.$on('user-session-set', () => {
            if (!this.hasInitialisedFromSession) {
                this.activate();
                this.hasInitialisedFromSession = true;
            }
        });

        this.init();
        this.activate();
    }

    init() {
        this.isBusy = true;
        this.query = '';
        this.buildingsDataService = this.BuildingsService;
        this.webDocumentApprovalIndividual = {
            Comments: null,
            Attachments: []
        };
    }

    activate() {

        const userSession = this.LocalStorageService.retrieve('userSession');

        if (!userSession) {
            return;
        }

        this.selectedBuildingRef = this.BuildingsService.getSelectedBuildingRef();

        let buildingName = '';
        const userProfile = this.LocalStorageService.retrieve('userProfile');

        if (userProfile) {
            if (!this.selectedBuildingRef) {
                this.selectedBuildingRef = userProfile.BuildingProfiles[0].SchemeReference;
            }
            const selectedBuilding = userProfile.BuildingProfiles.find((building) => {
                return building.SchemeReference.toUpperCase().trim() === this.selectedBuildingRef.toUpperCase().trim();
            });

            if (selectedBuilding) {
                buildingName = selectedBuilding.SchemeName;
            }
        }
        this.getDocumentApprovals();
    }

    async _onSelectedBuildingChanged(event, schemeRef) {
        try {
            if (schemeRef) {
                this.activate();
            }
        } catch (err) {
            console.error('Error while loading document info:', err);
        } finally {
            this.isBusy = false;
        }
    }

    getDocumentApprovals() {
        this.isBusy = true;
        this.$timeout(async () => {
            try {
                if (this.selectedBuildingRef && this.selectedBuildingRef != null) {
                    const approvalsData = await this.ApprovalDocumentsDataService.getDocumentApprovals(this.selectedBuildingRef);
                    this.approvalsData = approvalsData;
                }

            } catch (err) {
                console.error('Error while loading document info:', err);
            } finally {
                this.isBusy = false;
            }
        });
        this.isBusy = false;
    }

    populateHistoryDocumentViewModal(approval) {
        const approvalId = approval.Id;

        for (let i = 0; i < this.approvalsData.length; i++) {
            const currApproval = this.approvalsData[i];
            if (currApproval.Id == approvalId) {
                this.webDocumentApprovalIndividual = currApproval;
                for (let j = 0; j < this.webDocumentApprovalIndividual.Attachments.length; j++) {
                    if (this.webDocumentApprovalIndividual.Attachments[j].Id) {
                        const path = pretorOnlineUrl + '/documents/byid/' + this.webDocumentApprovalIndividual.Attachments[j].Id.toLowerCase();
                        this.iframeApprovalDocuments = this.$sce.trustAsResourceUrl(path);
                        this.selectedDocumentIndex = j;
                        this.selectedApprovalId = approvalId;
                        break;
                    }
                }

                return;
            }
        }
    }

    getInvoicePath(index = -1) {
        if (index === -1) {
            return;
        }
        const path = pretorOnlineUrl + '/documents/byid/' + this.webDocumentApprovalIndividual.Attachments[index].Id.toLowerCase();
        this.iframeApprovalDocuments = this.$sce.trustAsResourceUrl(path);
        this.selectedDocumentIndex = index;
        //mapping mobileview download button name.
        this.selectedDocumentTypeDesc = this.webDocumentApprovalIndividual.Attachments[index].Description;
    }

    approveDocument(approvalId) {
        this.isBusy = true;
        this.DestroyModal('#documentViewModal');
        this.currentSchemeRef = this.currentSchemeRef ? this.currentSchemeRef : this.BuildingsService.getSelectedBuildingRef();
        this.ApprovalDocumentsDataService
            .approveDocument(approvalId, this.currentSchemeRef)
            .then(
                (results) => {
                    if (results.WasSuccessful) {
                        this.NotificationService.success('APPROVED');
                    } else {
                        this.NotificationService.success('FAILED');
                    }
                },
                (err) => {
                    this.NotificationService.error('FAILED', err);
                }
            )
            .finally(() => {
                this.isBusy = false;
                this.getDocumentApprovals();
            });
    }

    DestroyModal(modalId) {
        angular.element(modalId).modal('hide');
        angular.element('body').removeClass('modal-open');
        angular.element('.modal-backdrop').remove();
    }

    rejectDocument(approvalId) {
        this.isBusy = true;
        this.DestroyModal('#documentViewModal');
        this.currentSchemeRef = this.currentSchemeRef ? this.currentSchemeRef : this.BuildingsService.getSelectedBuildingRef();
        this.ApprovalDocumentsDataService
            .rejectDocument(approvalId, this.currentSchemeRef)
            .then(
                (results) => {
                    if (results.WasSuccessful) {
                        this.NotificationService.success('REJECTED');
                    } else {
                        this.NotificationService.success('FAILED');
                    }
                },
                (err) => {
                    this.NotificationService.error('FAILED', err);
                }
            )
            .finally(() => {
                this.isBusy = false;
                this.getDocumentApprovals();
            });
    }

    queryDocument(approvalId) {
        this.isBusy = true;
        this.DestroyModal('#documentViewModal');
        this.currentSchemeRef = this.currentSchemeRef ? this.currentSchemeRef : this.BuildingsService.getSelectedBuildingRef();

        this.ApprovalDocumentsDataService
            .queryDocument(approvalId, this.query, this.currentSchemeRef)
            .then(
                (results) => {
                    if (results.WasSuccessful) {
                        this.NotificationService.success('QUERIED');
                    } else {
                        this.NotificationService.success('FAILED');
                    }
                    this.query = '';
                },
                (err) => {
                    this.NotificationService.error('FAILED', err);
                }
            )
            .finally(() => {
                this.isBusy = false;
                this.getDocumentApprovals();
            });
    }

}
